import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private appConfig: any;

  constructor(private http: HttpClient) { }

  loadAppConfig() {
    return this.http.get('/assets/config.json').pipe(
      tap((data) => {
        this.appConfig = data;
      })
    );
  }


  // This is an example property ... you can make it however you want.
  get busSvcURL() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.busSvcURL;
  }
  get OBPortalSvcURL() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.OBPortalSvcURL;
  }
  get url() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.url;
  }
  get appTitle() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.appTitle;
  }
  get imagepath() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.imagepath;
  }
  get OBRebookAgent() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.OBRebookAgent;
  }
  get clientKey() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.clientKey;
  }
  get apiLoginID() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.apiLoginID;
  }
  get shorexURL() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.shorexURL;
  }
  get confirmBookingURL() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.confirmBookingURL;
  }
  get PCIURL() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.PCIURL;
  }

  get OBRebookMaint() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.OBRebookMaint;
  }

  get DetailedLogging() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.DetailedLogging;
  }

  get mealSelectionCutoffHour() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.mealSelectionCutoffHour;
  }

  get mealSelectionCutoffMinute() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.mealSelectionCutoffMinute;
  }

  get mealSelectionDisplayedCutoffTime() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.mealSelectionDisplayedCutoffTime;
  }

  get weatherAPIKey() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.weatherAPIKey;
  }

  get weatherURL() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.weatherURL;
  }

  get EnrichmentGuideRefreshWindow() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.EnrichmentGuideRefreshWindow;
  }

  get IsAppInsightsEnabled() {
    // IF THERE IS NO CONFIG THROW AN EXCEPTION....
    if (!this.appConfig) throw Error('Config file not loaded!');
    // ELSE RETURN THE DESIRED VALUE....
    return this.appConfig.IsAppInsightsEnabled;
  }

  get AppInsightsConnectStr() {
    if (!this.appConfig) throw Error('Config file not loaded!');
    return this.appConfig.AppInsightsConnectStr;
  }

  get authorizeNetAcceptJsUrl() {
    if (!this.appConfig) throw Error('Config file not loaded!');
    return this.appConfig.authorizeNetAcceptJsUrl;
  }

  get authorizeNetSandboxAcceptJsUrl() {
    if (!this.appConfig) throw Error('Config file not loaded!');
    return this.appConfig.authorizeNetSandboxAcceptJsUrl;
  }

  get ProxyUrl() {
    // IF THERE IS NO CONFIG THROW AN EXCEPTION....
    if (!this.appConfig) throw Error('Config file not loaded!');
    // ELSE RETURN THE DESIRED VALUE....
    return this.appConfig.ProxyUrl;
  }

  /**
   * Controls the portal home “Points of Interest” tile (/enrichmentguide).
   *
   * To UNHIDE (show the link again):
   * 1. In the runtime `config.json` that your build serves (see `angular.json`
   *    `fileReplacements` from `environment/*` → `assets/config.json`, or whatever
   *    pipeline deploys), set `"showPointsOfInterest": true`.
   * 2. Deploy / refresh clients so they load updated config (may require hard refresh
   *    if cached).
   *
   * Omit the key or set to false to keep the tile hidden.
   */
  get showPointsOfInterest(): boolean {
    if (!this.appConfig) return false;
    return this.appConfig.showPointsOfInterest === true;
  }
}
